import { useHistory, useParams } from "react-router";
import { ApiLoadingSpinner, BreadCrumb, Header } from "@funcional/react-ui";
import {
  useProgram,
  useSetProgramRegistrationPolicy,
  useUpdateProgram,
  useResetEntireCache,
} from "@pbm/programs/hooks";
import ProgramForm from "@pbm/programs/components/ProgramForm";
import { IGraphQLError } from "@common/contracts";
import { useState } from "react";

export default function EditProgramPage() {
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  let { programCode }: { programCode: string } = useParams();
  const setRegistrationPolicy = useSetProgramRegistrationPolicy();
  const setResetEntireCache = useResetEntireCache();

  const {
    status: fetchStatus,
    data: fetchData,
    error: fetchError,
  } = useProgram(programCode);

  const { isLoading, isSuccess, mutateAsync } = useUpdateProgram();

  const history = useHistory();

  const onSubmit = async (input: any) => {
    try {
      if (input.registrationPeriodEnd === "") {
        input.registrationPeriodEnd = null;
      }
      if (input.registrationPeriodStart === "") {
        input.registrationPeriodStart = null;
      }

      const registrationPolicyId = input?.registrationPolicyId;
      delete input.registrationPolicyId;
      const updatedRecord = await mutateAsync(input);
      if (updatedRecord) {
        await setRegistrationPolicy.mutateAsync({
          programCode: input.code,
          registrationPolicyId: registrationPolicyId || null,
        });
      }
      await setResetEntireCache.mutateAsync();
      return history.push(`/pbm/programs/${updatedRecord.code}`);
    } catch (error: any) {
      console.error(error);
      if (error.response.errors) {
        return setGraphQLErrors(error.response.errors || []);
      }
      setGraphQLErrors([
        {
          message:
            "Não foi possível salvar o registro, tente novamente mais tarde.",
        },
      ]);
    }
  };

  return (
    <>
      <Header title="Editar Programa" backTo={`/pbm/programs/${programCode}`}>
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/pbm/programs", label: "Programas" },
            {
              path: `/pbm/programs/${programCode}`,
              label: programCode,
            },
            { label: "Editar" },
          ]}
        />
      </Header>

      <div>
        {fetchStatus === "loading" ? (
          <ApiLoadingSpinner />
        ) : fetchStatus === "error" ? (
          <span>Erro: {JSON.stringify(fetchError)}</span>
        ) : fetchData ? (
          <ProgramForm
            isLoading={isLoading || isSuccess}
            onSubmit={onSubmit}
            defaults={fetchData}
            graphQLErrors={graphQLErrors}
          />
        ) : (
          <div>Registro não encontrado.</div>
        )}
      </div>
    </>
  );
}
